import React from 'react';
import cn from 'classnames';
import classes from './desktop-item-control.scss';
export function DesktopItemControl({
  removeBtnText,
  editBtnText,
  isSavedForLater,
  isEditPossible,
  onEditClick,
  onMoveToCartClick,
  onRemoveClick,
  onMoveToDraftClick,
  isAddToCardAvailable,
  isSaveForLaterAvailable,
  isRemoveItemAvailable
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.productMenu
  }, isEditPossible && /*#__PURE__*/React.createElement("div", {
    className: cn(classes.editMenuItem, {
      [classes.savedForLaterPM]: isSavedForLater
    }),
    "data-button": "Edit",
    onClick: onEditClick
  }, editBtnText), isAddToCardAvailable && /*#__PURE__*/React.createElement("div", {
    className: cn(classes.draftMenuItem, {
      [classes.savedForLaterPM]: isSavedForLater
    }),
    "data-button": "MoveToCart",
    onClick: onMoveToCartClick
  }, "Add to cart"), isSaveForLaterAvailable && /*#__PURE__*/React.createElement("div", {
    className: cn(classes.draftMenuItem, {
      [classes.savedForLaterPM]: isSavedForLater
    }),
    "data-button": "MoveToDraft",
    onClick: onMoveToDraftClick
  }, "Save for later"), isRemoveItemAvailable && /*#__PURE__*/React.createElement("div", {
    className: cn(classes.removeMenuItem, {
      [classes.savedForLaterPM]: isSavedForLater
    }),
    "data-button": "Remove",
    onClick: onRemoveClick
  }, removeBtnText));
}